import { useEffect, useState } from 'react';

const useFetch = (
  service?: () => Promise<any>, // eslint-disable-line
  dependency: any[] = [] // eslint-disable-line
) => {
  const [isLoading, isLoadingSet] = useState<boolean>(false);
  const [hasError, hasErrorSet] = useState<boolean>(false);
  const [error, errorSet] = useState<any>(); // eslint-disable-line

  const [content, dataSet] = useState<any>(); // eslint-disable-line

  useEffect(() => {
    if (!service) {
      isLoadingSet(false);
      return undefined;
    }

    let cancelled = false;

    hasErrorSet(false);
    errorSet(undefined);
    isLoadingSet(true);

    const serviceCall = service();

    serviceCall
      .then((res) => {
        if (cancelled) return;
        dataSet(res.data);
        isLoadingSet(false);
      })
      .catch((e) => {
        if (cancelled) return;
        isLoadingSet(false);
        hasErrorSet(true);
        errorSet(e);
      });

    return () => {
      cancelled = true;
    };
  }, dependency);

  return { isLoading, content, hasError, error };
};

export { useFetch };
